import axios from 'axios';

const secure_accesscode_key = process.env.REACT_APP_MS_API_KEY;

const sendSACCode = async (phoneNumber, type) => {
    let data = JSON.stringify({
        "to": "+1" + phoneNumber,
        "channel": type,
        "service": "addshare"
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/sac/send-twilio-code',
        headers: { 
            'Ocp-Apim-Subscription-Key': secure_accesscode_key, 
            'Content-Type': 'application/json'
        },
        data: data
    };
    try {
        const response = await axios(config);
        // Optionally check for response status
        if (response.status >= 200 && response.status < 300) {
            return { success: true, data: response.data };
        } else {
            return { success: false, error: response.data || 'Unexpected response status' };
        }
    } catch (error) {
        // You can extract more details if needed
        return { 
            success: false, 
            error: error.response?.data || error.message || 'Unknown error'
        };
    }
};
export { sendSACCode };

const verifySACCode = async (phoneNumber, code) => {
    let data = JSON.stringify({
        "to": "+1" + phoneNumber,
        "code": code,
        "service": "addshare"
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/sac/verify-twilio-code',
        headers: { 
            'Ocp-Apim-Subscription-Key': secure_accesscode_key, 
            'Content-Type': 'application/json'
        },
        data: data
    };

    try {
        const response = await axios.request(config);
        return response.data;
    } catch (error) {
        return error;
    }
}
export { verifySACCode };